if(typeof lottie === 'undefined') { var e = new Error("Cannot find module 'lottie'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = lottie;